import Fetch from '../utils/fetch';
import { InternalAddress, Region, RegionConfigApi } from '../types/orderTypes';
import { settings } from '../settings';
type RegionConfig = {
  temperatureControlEnabled: boolean;
  handoverPointAddresses: InternalAddress[];
  hubAddress: InternalAddress;
};

const hubMap: Map<Region, RegionConfig> = new Map();

export async function initializeHubConfig(): Promise<boolean> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/geography/region/config`,
  });
  if (response.ok) {
    const regionConfig = (await response.json()) as RegionConfigApi[];
    regionConfig.forEach(config =>
      hubMap.set(config.region, {
        hubAddress: config.hubAddress,
        temperatureControlEnabled: config.temperatureControlEnabled,
        handoverPointAddresses: config.handoverPointAddresses,
      })
    );
  }
  return response.ok;
}

export function getHubConfig(region: Region): RegionConfig | undefined {
  return hubMap.get(region);
}
export const warehouseLocations: {
  [region in Region]: { [location: string]: string };
} = {
  OSLO: {
    SKØYEN: 'SKØYEN',
    RYEN: 'RYEN',
    ALNA: 'ALNA',
  },
  VESTFOLD: {
    VESTFOLD: 'VESTFOLD',
  },
  BERGEN: {
    BERGEN: 'BERGEN',
  },
  STAVANGER: {
    STAVANGER: 'STAVANGER',
  },
  TRONDHEIM: {
    TRONDHEIM: 'TRONDHEIM',
  },
  GRENLAND: {
    GRENLAND: 'GRENLAND',
  },
  OSTFOLD: {
    OSTFOLD: 'OSTFOLD',
  },
  KRISTIANSAND: {
    KRISTIANSAND: 'KRISTIANSAND',
  },
};

export function regionSupportsTemperatureControl(region: Region): boolean {
  return hubMap.get(region)?.temperatureControlEnabled || true;
}

export function hubWarehouseLocationsByRegion(region: Region): string {
  switch (region) {
    case Region.OSLO:
      return warehouseLocations.OSLO.ALNA;
    case Region.VESTFOLD:
      return warehouseLocations.VESTFOLD.VESTFOLD;
    case Region.BERGEN:
      return warehouseLocations.BERGEN.BERGEN;
    case Region.STAVANGER:
      return warehouseLocations.STAVANGER.STAVANGER;
    case Region.TRONDHEIM:
      return warehouseLocations.TRONDHEIM.TRONDHEIM;
  }
}

export function arrayOfWarehouseLocations(
  addDefaultLocation = true,
  lowerCaseResult = true
): string[] {
  const arrayOfLocations = [];
  Object.keys(warehouseLocations).forEach(key =>
    Object.keys(warehouseLocations[key]).forEach(location =>
      arrayOfLocations.push(
        lowerCaseResult ? location.toLocaleLowerCase() : location
      )
    )
  );
  if (addDefaultLocation) {
    arrayOfLocations.push(lowerCaseResult ? 'warehouse' : 'WAREHOUSE');
  }

  return arrayOfLocations;
}

export function getWarehouseNameForShelfId(shelfId: string): string {
  const warehouseLocations = getAllWarehouseLocations();
  const location = Object.keys(warehouseLocations).find(
    key => key.toLowerCase() === shelfId.toLowerCase()
  );
  return location ? warehouseLocations[location] : 'undefined';
}

export function getAllWarehouseLocations(): { [location: string]: string } {
  const locations = {};
  Object.keys(warehouseLocations).forEach(region =>
    Object.keys(warehouseLocations[region]).forEach(location => {
      locations[location] = warehouseLocations[region][location];
    })
  );

  return locations;
}
